import client from "../../utils/client";
import { endPoints } from "../../constants/configuration";

export const postCampaignApi = async ({
  tenantId,
  authToken,
  userId,
  params,
  payload,
}) => {
  try {
    const { data } = await client().post(
      `${endPoints.beki}/v2${endPoints.campaign}`,
      payload,
      {
        params,
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const getCampaignApi = async ({
  tenantId,
  authToken,
  userId,
  params,
}) => {
  try {
    const { data } = await client().get(
      `${endPoints.beki}/v2${endPoints.campaign}`,
      {
        params,
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const postTenantDetailsByMandateIdApi = async ({
  tenantId,
  authToken,
  userId,
  payload,
}) => {
  try {
    const { data } = await client().post(
      `${endPoints.beki}/miscellanous/mandate/tenantdetails`,
      payload,
      {
        headers: {
          common: {
            tai_tenant: parseInt(tenantId),
            tai_token: authToken,
            tai_user: userId,
          },
        },
      }
    );
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};

export const getThirdPartyAccountApi = async ({ tenantId, authToken, userId }) => {
  try {

    const { data } = await client().get("/beki/account?list=all", {
      headers: {
        common: {
          tai_tenant: parseInt(tenantId),
          tai_token: authToken,
          tai_user: userId,
        },
      },
    });
    return data;
  } catch (error) {
    // get axios errors from error.response
    console.log(error);
    throw error;
  }
};
